import type { Suggestions } from '@mint-sdk/api-recommendations';

type ColorImpact = 'error' | 'success' | 'secondary';
type SignImpact = 'Add' | 'Subtract' | 'Equal' | 'ArrowDown' | 'ArrowUp';

type ValueImpact = {
  color: ColorImpact;
  sign: SignImpact;
  percentageSign: SignImpact;
};

export const getProposedValueImpact = (
  widget: Suggestions.ForecastedKPIItemType,
): ValueImpact => {
  const { percentageChange, isIncreasePositive } = widget;

  const isNegative = Number(percentageChange) <= 0;
  const isIncreasePosMetric = isIncreasePositive || isIncreasePositive === null;

  const withoutChange = percentageChange === null || percentageChange === 0;

  const isErrorMetric = isNegative === isIncreasePosMetric;

  if (withoutChange) {
    return {
      percentageSign: 'Equal',
      color: 'secondary',
      sign: 'Equal',
    };
  }

  if (isErrorMetric) {
    return {
      percentageSign: isNegative ? 'ArrowDown' : 'ArrowUp',
      color: 'error',
      sign: isNegative ? 'Subtract' : 'Add',
    };
  }

  return {
    percentageSign: isNegative ? 'ArrowDown' : 'ArrowUp',
    color: 'success',
    sign: isNegative ? 'Subtract' : 'Add',
  };
};
